import { render, staticRenderFns } from "./ServiceOrdersTable.vue?vue&type=template&id=18f2d291&scoped=true"
import script from "./index.js?vue&type=script&lang=js&external"
export * from "./index.js?vue&type=script&lang=js&external"
import style0 from "./ServiceOrdersTable.vue?vue&type=style&index=0&id=18f2d291&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18f2d291",
  null
  
)

export default component.exports